import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        regBasicinfoId: null, // 注册人员主键信息
        regType: null // 注册类型
      },
      // 查询表单基础数据
      formSearchList: [
        {
          label: "注册类型：",
          type: "select",
          value: "regType",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201507131626360048"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "注册类型",
          prop: "regTypeName",
          isShow: true
        },
        {
          label: "注册等级",
          prop: "regLevelName"
        },
        {
          label: "注册专业",
          prop: "regTradeType"
        }
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0
    };
  },

  // 接收父组件传递的数据
  props: {

  },

  // 模板编译完成
  mounted() {},
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/regPersonReginfo/list", {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 选择
     */
    fun_DetailSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面数据
        this.$parent.$parent.$parent.fun_SetRegLevel(e.val);
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    }
  }
};
